import { useEffect } from 'react'

import { Credits } from '../Common/Credits/Credits'
import { GoToBack } from './../Common/GoToBack'

// Detecta si el visitante usa Windows, para priorizar visualmente el tile
// correspondiente. No es posible distinguir de forma confiable Mac Intel de
// Mac con chip Apple desde el navegador (macOS siempre reporta "MacIntel",
// incluso en Apple Silicon), así que cualquier caso que no sea Windows se
// trata como "Mac primero".
const IsWindows = () => {
    try {
        const ua = navigator?.userAgent || navigator?.platform || ''
        return /win/i.test(ua)
    } catch (error) {
        return false
    }
}

const Download = () => {
    const isWindows = IsWindows()

    useEffect(() => {
        document.body.classList.add('BodyComplete')
        document.body.classList.add('Background--Ztudia')

        return ()  => {
            document.body.classList.remove('Background--Ztudia')
        }
    }, [])

    // El botón "Descargar ahora" se ve rosa (relleno) solo en el/los tile(s) que
    // corresponden al sistema operativo detectado; los demás quedan en contorno.
    const windowsButtonClass = isWindows ? 'Btn__Ztudia--Primary' : 'Btn__Ztudia--PrimaryOutline'
    const macButtonClass = isWindows ? 'Btn__Ztudia--PrimaryOutline' : 'Btn__Ztudia--Primary'

    const windowsTile = (
        <div className='Download__Tiles__Item'>
            <i className="bi bi-windows Download__Tiles__Item__Icon"></i>
            <p className="Download__Text--Center">Ztudia para Microsoft Windows</p>
            <a className={`${windowsButtonClass} Download__Tiles__Item__Button`} href="./files/download/ztudiaappforw.zip" download><i className="bi bi-download"></i> Descargar ahora</a>
        </div>
    )

    const macGroup = (
        <div className='Download__Tiles__MacGroup'>
            <div className='Download__Tiles__Item'>
                <i className="bi bi-apple Download__Tiles__Item__Icon"></i>
                <p className="Download__Text--Center">Ztudia para macOS</p>
                <p className="Download__Text--Center Download__Tiles__Item__Subtitle">Para Mac con chip Intel</p>
                <a className={`${macButtonClass} Download__Tiles__Item__Button`} href="./files/download/ztudiaappform_i.zip" download><i className="bi bi-download"></i> Descargar ahora</a>
            </div>

            <div className='Download__Tiles__Item'>
                <i className="bi bi-apple Download__Tiles__Item__Icon"></i>
                <p className="Download__Text--Center">Ztudia para macOS</p>
                <p className="Download__Text--Center Download__Tiles__Item__Subtitle">Para Mac con chip Apple (M1/M2/M3...)</p>
                <a className={`${macButtonClass} Download__Tiles__Item__Button`} href="./files/download/ztudiaappform_m.zip" download><i className="bi bi-download"></i> Descargar ahora</a>
            </div>
        </div>
    )

    return (
        <>
            <header className="container Header">
                <div className="Header-Side1">
                    <div className="Header-Brand">
                        <img src="./img/brand/Ztudia-Logotipo-Negro-66x26.png" alt="Logotipo-Ztudia" className="Header-Image" />
                    </div>
                </div>

                <div className="Header-Side2"></div>

                <div className="Header-Side3"></div>
            </header>

            <main className="Download container Container-FullHeight Fonts--PlusJakartaSans">
                <GoToBack url={'/'} />

                <img src="./img/brand/Ztudia-Logotipo-Negro-350x135.png" alt="Logotipo-Ztudia" className="Download__Logo" />
                <p className='Download__Text--Center'>Descarga la solución Ztudia para comenzar tu proceso de certificación</p>

                <div className='Download__Tiles'>
                    {isWindows ? (
                        <>
                            {windowsTile}
                            {macGroup}
                        </>
                    ) : (
                        <>
                            {macGroup}
                            {windowsTile}
                        </>
                    )}
                </div>
            </main>

            <Credits />
        </>
    )
}

export { Download };
